import { useSelector } from 'react-redux';
import Link from 'next/link';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';
import WideContainer, { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { WithSkeleton } from '@r1-frontend/ui-react/components/loaders/Skeleton';
import { FullWidthListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';

import Routers from '~/src/features/equipment/pageBlocks/Routers';
import { PromoTextWithStyleHeading2 } from '~/src/features/internetV2/components/typography';
import { TState } from '~/src/store';

import * as ST from './styled';

export const RoutersContainer = (): JSX.Element => {
    const isLaptop = useMatchMediaByWidth(wideBreakpoints.laptop);
    const { routers, isLoading } = useSelector((state: TState) => state.internetReducer);

    return (
        <ST.IndentContainerWithBackground
            $desktop={[80, 0]}
            $mobile={[36, 0]}
        >
            <WideContainer>
                <FullWidthListContainer $wrap={'nowrap'} $direction={'column'} $size={0}>
                    <PromoTextWithStyleHeading2 as={'h2'}>Роутеры</PromoTextWithStyleHeading2>
                    <WithSkeleton
                        isLoading={isLoading}
                        height={354}
                        width={304}
                        count={isLaptop ? 2 : 3}
                        inline
                        borderRadius={BorderRadius.OuterBlockRadius}
                        style={{
                            margin: '24px 24px 24px 0',
                        }}
                    >
                        <Routers
                            data-test='router-list'
                            routers={routers}
                        />
                    </WithSkeleton>
                    <ButtonGroup>
                        <Link href={'/internet/equipment'} passHref>
                            <Button
                                size={'large'}
                                bType={'secondary'}
                            >
                                Подробнее
                            </Button>
                        </Link>
                    </ButtonGroup>
                </FullWidthListContainer>
            </WideContainer>
        </ST.IndentContainerWithBackground>
    );
};
